'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { fetchReviews } from '../../lib/reviewsApi'
import ReviewWall from '../reviews/ReviewWall'
import './home-v2.css'

// T-12.1: Client testimonials. Real reviews managed in /admin (GET
// /api/reviews), the same rows /reviews shows. No review JSON-LD here:
// self-serving review markup is ignored by Google and can trigger a manual
// action (see lib/schema.ts).
const HOME_LIMIT = 6

export default function ClientTestimonials() {
  const [reviews, setReviews] = useState([])

  useEffect(() => {
    let active = true
    fetchReviews().then((data) => {
      if (active) setReviews(data)
    })
    return () => {
      active = false
    }
  }, [])

  // Nothing published (or the API is down): leave the section out entirely
  // rather than show an empty block.
  if (!reviews.length) return null

  return (
    <section className="hv2 hv2-section is-white">
      <div className="hv2-inner">
        <div className="hv2-head centered" data-rv="0.4">
          <span className="hv2-eyebrow">Client Reviews</span>
          <h2>What Our <span className="hv2-hl">Clients Say</span></h2>
          <p>Real feedback from agencies and businesses we have worked with.</p>
        </div>

        <div data-rv="0.1" style={{ '--rv-y': '24px', '--rv-dur': '.45s', '--rv-ease': 'ease-out' }}>
          <ReviewWall reviews={reviews.slice(0, HOME_LIMIT)} />
        </div>

        <div className="rc-more">
          <Link href="/reviews">
            Read all client reviews <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  )
}
